<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Encuesta</title>
  <!-- <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
  <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"> -->
</head>
<body>
    <header style="background-color: #1e293be3 !important ;" class="d-flex justify-content-between align-items-center text-white p-3">
        <img src="../../../../../assets/images/LogoCMQCH.png" alt="" class="img-fluid" style="max-height: 50px;">
        <h1 class="text-center flex-grow-1">CMQCH</h1>
        <img src="../../../../../assets/images/LogoCMQCH.png" alt="" class="img-fluid" style="max-height: 50px;">
      </header>

      <main class="container mt-4">

    <form>
        <div>
          <div class="text-center" >
            <button style="margin-right: 5px;" mat-raised-button color="primary" (click)="refresh()">Refrescar Encuesta</button>

            <button mat-raised-button color="warn" (click)="salir()">Salir</button>
          </div>
            <div style="text-align: center;" *ngFor="let it of preguntas" >
                <h2>{{it.descripcionEncuesta}}</h2>
                <div *ngFor="let item of it.preguntas"  class="card mb-3">
                  <div >

                  <div  class="card-header bg-secondary text-white text-center">
                    <h2>{{item.pregunta}}</h2>
                  </div>
                  <div class="col-lg-12"  style="text-align: center;" class="card-body">
                      <mat-radio-group  (change)="onRadioChange($event,it)">
                        <mat-radio-button  [disabled]="!item.preguntaActiva" [checked]="i.seleccinado" class="col-lg-12"  style="margin: 2%;" *ngFor="let i of item.opcionesRespuesta"  [value]="i">
                          {{i.opcionRespuesta}}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                    </div>
                    <div *ngIf="!item.preguntaActiva" class="mt-4">
                     <div class="alert alert-success text-center" role="alert">
                       La pregunta ya fue finalizada <br>
                       <span style="font-size: 50px;" ><i class="fa fa-check-circle"></i></span>
                     </div>
                   </div> 
                </div>
        </div>

      </div>

      <div *ngIf="mostrarPregunta" class="mt-4">
        <div class="alert alert-success text-center" role="alert">
            Gracias por contestar la pregunta. <br>
            <span style="font-size: 50px;" ><i class="fa fa-check-circle"></i></span>
        </div>
    </div>





      <!-- Agregar más preguntas aquí -->

      <!-- <button mat-raised-button color="primary" class="w-100">Enviar Respuestas</button> -->
    </form>
  </main>

  <footer style="background-color:  #1e293be3;" class="text-white text-center py-3 mt-4">
    <div class="container">
      <p>&copy; 2024 Todos los derechos reservados.</p>
    </div>
  </footer>
</body>
</html>
